import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import { actions } from "./redux/actions";

import { environmentName } from './shared/settings/config';
import { FeaturesRouter } from './routers/FeaturesRouter';

import './App.scss';

function App() {

	const dispatch = useDispatch();

	useEffect(() => {
		const rootElement = document.getElementById('root');
		if ( rootElement ) {
			rootElement.classList.add(environmentName);
		}

		dispatch(actions.setResizeData({windowInnerWidth: window.innerWidth}));

		window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
	}, []);

	const handleResize = () => {
        dispatch(actions.setResizeData({windowInnerWidth: window.innerWidth}));
    };

	return (
		<Router>
			<Route component={FeaturesRouter} />
		</Router>
	);
}

export default App;
